import { CharacterFormFields } from "./types";

export const chatBotrequiredFields = [
  CharacterFormFields.AVATAR,
  CharacterFormFields.NAME,
  CharacterFormFields.TITLE,
  CharacterFormFields.PERSONA,
  CharacterFormFields.GREETING,
  CharacterFormFields.GUIDELINES,
];

export const SUGGESTION_FIELDS = {
  AVATAR_PROMPT: "image",
};

export const SUCCESS_MESSAGE = "Chatbot saved successfully";

export const GROUP_SUCCESS_MESSAGE = "Group saved successfully";

export const REQUIRED_FIELD_MESSAGE = "This field is required";

export const MIN_REQUIRED_FIELD_MESSAGE = "At least 3 characters are required";

export const TAG_LIMIT_REACHED_MESSAGE = "Tag limit reached";

export const PLACEHOLDER_STYLING = "placeholder:text-gray-10";
